import { useCallback, useRef } from "react";
import { IGif } from "services/types";
import { ViewRegion, metrics } from "utils/metrics";
import { apiMain } from "services";

interface UsePlayerMetrics {
  gif: IGif;
  source: ViewRegion;
  position: number;
  sourceId: string | null;
  isHLS: boolean;
}

export const usePlayerMetrics = ({ gif, source, position, sourceId, isHLS }: UsePlayerMetrics) => {
  const isViewMetricSent = useRef<boolean>(false);

  const viewMetricQuery = useCallback(async (gif: IGif) => {
    const loggedUser = await metrics.getUserName();
    await metrics.sendGifView({
      gifId: gif.id,
      tags: gif.tags,
      source: source,
      position: position,
      boosted: !!gif.cta,
      userName: loggedUser || null
    });
  }, [position, source]);

  const onViewMetric = useCallback(async () => {
    if (!isViewMetricSent.current) {
      await viewMetricQuery(gif);
      isViewMetricSent.current = true;
    }
  }, [gif, viewMetricQuery]);

  const onProfileMetric = useCallback(async (value: string) => {
    await apiMain.sendGifMetrics({
      event: "profile_open",
      gif: value,
      source: sourceId,
    });
  }, [sourceId]);

  const onVideoLoadMetric = useCallback((duration: number) => {
    apiMain.sendVideoLoaded({
      duration,
      isHLS
    });
  }, [isHLS]);

  return {
    viewMetricQuery,
    onViewMetric,
    onProfileMetric,
    onVideoLoadMetric
  };
};
